import {
  formatClockTimeAmPm,
  formatGaraazSlotBoundLabel,
  parseGaraazSlotNumber,
} from "../../../components/DeliveryOptions/utils/deliveryTimeUtils";

export type OrderEtaGaraazSlot = {
  minGaraazSlot: number;
  eta?: string;
  startTime?: string;
  endTime?: string;
};

type OrderEtaEntry = {
  eta?: string;
  minGaraazSlot?: unknown;
  garaazSlotStartTime?: string;
  garaazSlotEndTime?: string;
};

export function pickOrderEtaMinGaraazSlot(
  orderEta: unknown,
): OrderEtaGaraazSlot | undefined {
  if (!Array.isArray(orderEta)) {
    return undefined;
  }

  for (let index = orderEta.length - 1; index >= 0; index -= 1) {
    const entry = orderEta[index] as OrderEtaEntry | undefined;
    const minGaraazSlot = parseGaraazSlotNumber(entry?.minGaraazSlot);
    if (minGaraazSlot == null) {
      continue;
    }

    return {
      minGaraazSlot,
      eta: entry?.eta,
      startTime: entry?.garaazSlotStartTime,
      endTime: entry?.garaazSlotEndTime,
    };
  }

  return undefined;
}

export function formatOrderEtaSlotLabel(
  slot: OrderEtaGaraazSlot,
): string {
  if (!slot.eta) {
    return `Slot ${slot.minGaraazSlot}`;
  }
  return formatGaraazSlotBoundLabel(slot.eta, slot.minGaraazSlot);
}

function formatHoverClock(hhmm: string): string {
  return formatClockTimeAmPm(hhmm).replace(":00 ", " ");
}

export function formatOrderEtaSlotTimings(
  slot: OrderEtaGaraazSlot,
): string {
  if (!slot.startTime || !slot.endTime) {
    return "";
  }
  return `${formatHoverClock(slot.startTime)} to ${formatHoverClock(slot.endTime)}`;
}

export function orderEtaEntryToGaraazSlot(
  entry: OrderEtaEntry | undefined,
): OrderEtaGaraazSlot | undefined {
  const minGaraazSlot = parseGaraazSlotNumber(entry?.minGaraazSlot);
  if (minGaraazSlot == null) {
    return undefined;
  }
  return {
    minGaraazSlot,
    eta: entry?.eta,
    startTime: entry?.garaazSlotStartTime,
    endTime: entry?.garaazSlotEndTime,
  };
}
